<script>
  import Button from "lib/components/Button.svelte";

  export let previousText = "Previous task";
  export let nextText = "Next 10";
  export let previousDisabled = false;
  export let nextDisabled = false;
  export let onMarkShown = () => {};
  export let onPrevious = () => {};
  export let onNext = () => {};
</script>

<div class="pagination-actions">
  <Button text="Mark shown as checked" variant="secondary" size="sm" on:click={onMarkShown} />
  <Button text={previousText} variant="secondary" size="sm" notAllowed={previousDisabled} on:click={onPrevious} />
  <Button text={nextText} variant="secondary" size="sm" notAllowed={nextDisabled} on:click={onNext} />
</div>

<style>
  .pagination-actions { display: flex; flex-wrap: wrap; align-items: center; gap: var(--control-gap); }
</style>
